<template>
  <ul class="navigation-bar" :class="{ show: hasNavigation }">
    <router-link tag="li" to="/" class="navigation-bar__item" :class="{ active: isCurrentRoute('home') }"><b class="navigation-bar__icon">home</b><p class="navigation-bar__label"></p></router-link>
    <router-link tag="li" to="/episodes" class="navigation-bar__item" :class="{ active: isCurrentRoute('episodes') }"><b class="navigation-bar__icon">menu</b><p class="navigation-bar__label"></p></router-link>
    <li tag="li" class="navigation-bar__item" :class="{ active: isCurrentRoute('episodes') }" @click="toggleMenu"><b class="navigation-bar__icon">more_vert</b><p class="navigation-bar__label"></p></li>
  </ul>
</template>

<style lang="scss" scoped>
.navigation-bar {
  position: fixed;
  display: flex;
  width: 100%;
  height: 55px;
  background-color: #FC8B00;
  text-align: center;
  bottom: -16px;
  left: 0;
  list-style: none;
  padding: 0;
  transition: transform 0.13s ease-in-out;
  transform: translateY(100%);
  z-index: 1000;
  user-select: none;

  &.show {
    transform: none;
  }

  &__label {
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    text-transform: uppercase;
    margin: 0;
  }

  &__item {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;

    &--0 {
      flex: 0;
    }

    &::before {
      position: absolute;
      content: '';
      width: 64px;
      height: 4px;
      background-color: #fc8b00;
      bottom: 0;
      left: calc(50% - 32px);
      transition: transform 0.13s ease-in-out;
      transform-origin: center;
      transform: scaleX(0);
    }

    &.active {
      &::before {
        transform: none;
      }
    }
  }

  &__icon {
    @extend .material-icons;
  }

  &__menu {
    @extend .material-icons;
    width: 55px;
    height: 55px;
    text-align: center;
    line-height: 55px;
    background-color: #fc8b00;
    cursor: pointer;

    &.hasMenu {
      background-color: lighten(#fc8b00, 7);
    }
  }
}
</style>

<script>
export default {
  data () {
    return {
      currentRoute: this.$router.history.current.name
    }
  },
  computed: {
    hasNavigation () {
      return this.$store.state.navigation
    },
    hasMenu () {
      return this.$store.state.menuVisibility
    }
  },
  watch: {
    '$route' (to, from) {
      this.currentRoute = to.name
    }
  },
  methods: {
    isCurrentRoute (routeName) {
      return this.currentRoute === routeName
    },
    toggleMenu () {
      this.$store.commit('setMenuVisibility', !this.hasMenu)
    }
  }
}
</script>
